import { createFileRoute } from '@tanstack/react-router'
import EditionMediaAndSales from 'Edition/components/sections/Content/EditionMediaAndSales'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/content-press-sales')({
    component: EditionMediaAndSales,
})
